import _ from 'lodash';

/**
 * Order ObjectList based on the order provided
 * @param  {Array} objectList Array of Objects
 * @param  {Array} orderArray Array of the order
 * @param  {Function} getObjectByKey Function to pluck out an object from the list
 * @return {Array} Ordered Array of Objects
 */
export function orderObjectList(objectList, orderArray, getObjectByKey) {
  let orderedObjects = null;

  if (orderArray && orderArray.length > 0 && _.isFunction(getObjectByKey)) {
    orderedObjects = [];

    _.each(orderArray, orderKey =>
      orderedObjects.push(getObjectByKey(orderKey, objectList))
    );
  } else {
    orderedObjects = _.cloneDeep(objectList);
  }

  return orderedObjects;
}

/**
 * Get a function that returns back an object from a list based on the passed in key matching the objectKey
 * @param  {String} objKey The object key
 * @return {Function} Returns the function to find the object
 */
export function createGetObjectByKey(objKey) {
  /**
   * The returned function
   * @param  {String} orderKey The key that needs to be found
   * @param  {Array} objectList The list of objects to filter
   * @return {Object} The found object
   */
  return function(orderKey, objectList) {
    let retObject = null;

    if (orderKey && objectList) {
      const filteredObjectList = objectList.filter(
        obj => obj[objKey] === orderKey
      );

      retObject =
        filteredObjectList.length > 0
          ? _.cloneDeep(_.head(filteredObjectList))
          : {};
    } else {
      retObject = {};
    }

    return retObject;
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/orderHelpers.js